import { useEffect, useRef } from 'react';

/**
 * useChiudiConEsc — Esc chiude una cosa aperta dell'Agenda (il pannello a
 * destra, il riquadro «Agende») DA DOVUNQUE SIA IL FUOCO.
 *
 * Fino alla revisione del 6/10/2026 Esc lo ascoltavano il pannello e il
 * riquadro sul proprio contenitore: funzionava solo col fuoco gia' dentro,
 * cioe' quando il pannello si era aperto da tastiera. Aperto col mouse - il
 * caso normale - il fuoco resta sull'appuntamento in griglia (o sul
 * pulsante «Agende»), e Esc non faceva niente, mentre i manuali scrivevano
 * «si chiude con la X o con Esc». Adesso si ascolta il documento finche'
 * la cosa e' aperta.
 *
 * UNA COSA PER TASTO. Esc e' di chi sta piu' in alto, e se sopra c'e' altro
 * che con Esc si chiude da se' tocca a lui, non a questo:
 *  - una finestra fuori dal contenitore (role="dialog" o aria-modal): la
 *    barra comandi, la firma sul computer, l'elenco dei ritardi;
 *  - un elenco o un menu aperto da un pulsante fuori dal contenitore
 *    (aria-expanded="true" con aria-haspopup o aria-controls): il menu a
 *    cassetto, «Nuovo» della barra in alto, il riquadro «Agende» quando ad
 *    ascoltare e' il pannello.
 * Il pulsante del Promemoria nell'angolo dice aria-expanded senza aprire un
 * elenco (resta aperto mentre si lavora) e non conta.
 *
 * `attivo` falso: Esc non chiude (il pannello mentre una firma e' in corso:
 * chiuderlo la interromperebbe). `contenitore` e' il ref della cosa stessa:
 * quello che sta DENTRO non e' «sopra».
 */
export default function useChiudiConEsc(attivo, contenitore, onChiudi) {
    const chiudi = useRef(onChiudi);
    chiudi.current = onChiudi;
    useEffect(() => {
        if (!attivo) return undefined;
        const tasto = (e) => {
            if (e.key !== 'Escape' || e.defaultPrevented) return;
            const proprio = contenitore.current;
            const sopra = [...document.querySelectorAll(
                '[role="dialog"], [aria-modal="true"], '
                + '[aria-expanded="true"][aria-haspopup], [aria-expanded="true"][aria-controls]',
            )].some((el) => !proprio || !proprio.contains(el));
            if (sopra) return;
            chiudi.current(e);
        };
        document.addEventListener('keydown', tasto);
        return () => document.removeEventListener('keydown', tasto);
    }, [attivo, contenitore]);
}
